export enum StreamingAvatarSessionState {
    INACTIVE = "inactive",
    CONNECTING = "connecting",
    CONNECTED = "connected",
}

export enum MessageSender {
    CLIENT = "CLIENT",
    AVATAR = "AVATAR",
}
